import SectionLabel from "@/components/SectionLabel";

const pillars = [
  {
    badge: "Communion",
    title: "A welcoming home",
    body: "We seek to become a parish where people are received with compassion, where faith is shared, and where no one feels abandoned.",
    numeral: "I.",
  },
  {
    badge: "Participation",
    title: "A listening Church",
    body: "We encourage active participation among lay leaders, families, youth, GKKs, ministries, and pastoral workers.",
    numeral: "II.",
  },
  {
    badge: "Mission",
    title: "A parish that goes forth",
    body: "We bring the Gospel beyond the church walls through service, formation, social action, and care for creation.",
    numeral: "III.",
  },
];

export default function Mission() {
  return (
    <section id="mission" className="py-24 md:py-36 bg-parchment-200 grain">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker="Our Direction"
          title="A parish for communion, participation, and mission."
          intro="Guided by the spirit of synodality, we build a community where every family, GKK, ministry, and servant-leader has a place in the mission of the Church."
        />

        <div className="mt-16 grid md:grid-cols-3 gap-px bg-parchment-400">
          {pillars.map((p) => (
            <article
              key={p.badge}
              className="group bg-parchment-100 p-10 md:p-12 hover:bg-parchment-50 transition-colors duration-500"
            >
              <div className="font-serif italic text-5xl text-terracotta/70 mb-4">
                {p.numeral}
              </div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-sage-dark font-sans mb-3">
                {p.badge}
              </div>
              <h3 className="font-serif text-2xl text-cocoa-900 mb-4">{p.title}</h3>
              <p className="font-sans text-cocoa-800 leading-relaxed font-light">
                {p.body}
              </p>
              <div className="mt-8 h-px w-10 bg-sage/60 group-hover:w-20 transition-all duration-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
